import { Bitmap, Stage, Sprite, SpriteSheet, Ticker } from '@createjs/easeljs';
import Journalist1 from '../spritesheets/press/person1.png';
import Journalist2 from '../spritesheets/press/person2.png';
import Journalist3 from '../spritesheets/press/person3.png';
import Journalist4 from '../spritesheets/press/person4.png';
import Journalist5 from '../spritesheets/press/person5.png';
import Journalist6 from '../spritesheets/press/person6.png';
import Journalist7 from '../spritesheets/press/person7.png';
import Journalist8 from '../spritesheets/press/person8.png';
import Journalist9 from '../spritesheets/press/person9.png';
import Chair from '../spritesheets/press/game_press_chair.png';
import { journalists } from './spritesheet-data';

const journalistImages = [
    Journalist1,
    Journalist2,
    Journalist3,
    Journalist4,
    Journalist5,
    Journalist6,
    Journalist7,
    Journalist8,
    Journalist9,
];

const journalistStageOrder = [1, 3, 5, 7, 0, 2, 4, 6, 8];

class PressAnimation {
    constructor() {
        this.stage = null;
        this.journalists = [];
        this.journalistsChairs = [];

        this._createSprites();
    }

    _createSprites() {
        for (let i = 0; i < journalists.length; i++) {
            const spriteSheet = new SpriteSheet({
                frames: journalists[i].frames,
                animations: journalists[i].animations,
                images: [journalistImages[i]],
            });

            const journalist = new Sprite(spriteSheet, 'sitting');
            this.journalists.push(journalist);
            this.journalists[i].scaleY = this.journalists[i].scaleX = 0.9;
            this.journalists[i].x = journalists[i].x;
            this.journalists[i].y = journalists[i].y;
            const chair = this._createChair();
            this.journalistsChairs.push(chair);
            this.journalistsChairs[i].x = this.journalists[i].x - 50;
            this.journalistsChairs[i].y = this.journalists[i].y - 20;
        }
    }

    _createChair() {
        let chair = new Bitmap(Chair);
        chair.scaleX = chair.scaleY = 0.9;
        return chair;
    }

    initialise(id) {
        this.stage = new Stage(id);
        journalistStageOrder.forEach(i => {
            this.stage.addChild(this.journalistsChairs[i]);
            this.stage.addChild(this.journalists[i]);
        });
        this.stage.update();
        Ticker.on('tick', this.stage);
    }

    destroy() {
        Ticker.off('tick', this.stage);
        journalistStageOrder.forEach(i => {
            this.stage.removeChild(this.journalistsChairs[i]);
            this.stage.removeChild(this.journalists[i]);
        });
        this.stage.clear();
        this.stage.update();
    }

    journalistStand(index) {
        this.journalists[index].gotoAndPlay('stand');
    }

    journalistSit(index) {
        this.journalists[index].gotoAndPlay('sit');
    }

    makeJournalistAngry(index) {
        this.journalists[index].gotoAndPlay('sad');
    }

    makeJournalistHappy(index) {
        this.journalists[index].gotoAndPlay('happy');
    }
}

export { PressAnimation };
